import { UpdateReleaseTrackArgs } from "../../../../api/releases/releaseAPI";
import { EditReleaseTrackFormState } from "../../../../atoms/forms/editReleaseTrackFormAtom";
import { ReleaseTrack } from "../../../../store/models/release";

export const handleUpdateReleaseTrackForm = async (
  releaseTrackForm: EditReleaseTrackFormState,
  updateReleaseTrack: (args: UpdateReleaseTrackArgs) => Promise<ReleaseTrack>,
) => {
  const args: UpdateReleaseTrackArgs = {
    artist: releaseTrackForm.artistName,
    featured_artists: releaseTrackForm.featuredArtists,
    title: releaseTrackForm.songTitle,
    supply_chain_main_genre: parseInt(releaseTrackForm.genre),
    supply_chain_secondary_genre: parseInt(releaseTrackForm.secondaryGenre),
    supply_chain_language: parseInt(releaseTrackForm.language),
    parental_advisory: parseInt(releaseTrackForm.parentalAdvisory),
  };
  return updateReleaseTrack(args);
};
